/**
 * @desc 退税匹配报表导出
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = any;
export function request(
  params: API.tms.taxRefundMatching.newExport.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/taxRefundMatching/export`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
